<proffeo-ui-dialog [title]="data.title | translate">
  <form
    (submit)="save($event)"
    id="file-explorer-name-form"
  >
    <proffeo-ui-input
      [formField]="nameForm.name"
      label="files.explorer.name"
    />
    @if (data.extension !== undefined) {
      <p class="text-proffeo-muted text-sm">{{ 'files.explorer.extension-unchanged' | translate }}</p>
    }
  </form>
  <div
    dialog-actions
    class="flex w-full justify-end gap-2"
  >
    <proffeo-ui-button
      text="close"
      matDialogClose
    />
    <proffeo-ui-button
      (clicked)="save()"
      [disabled]="nameForm().invalid()"
      text="save-and-close"
      variant="accent"
    />
  </div>
</proffeo-ui-dialog>
